import React from 'react';
import ModalForm from './ModalForm';
import { Table, TableCardHeader, CollapsibleRowTable } from './TableToggle';
import { fieldFormat } from '../helpers/utils';

interface AddMemberCollapsibleRowTableProps {
  name: string;
  canEdit?: boolean;
  data: any[];
  columns: any[];
  onSubmit: (values: any) => void;
  isOpenAdd: boolean;
  isOpenEdit: boolean;
  fields: any[];
  onAdd: () => void;
  onCloseAdd: () => void;
  row?: any;
  onCloseEdit: () => void;
  handleUpdateMember: (values: any) => void;
}

export const AddMemberCollapsibleRowTable = ({
  name,
  canEdit,
  data,
  columns,
  onSubmit,
  isOpenAdd,
  isOpenEdit,
  fields,
  onAdd,
  onCloseAdd,
  row,
  onCloseEdit,
  handleUpdateMember,
}: AddMemberCollapsibleRowTableProps) => (
  <>
    <div id={fieldFormat(name, '-table')}>
      {canEdit ? (
        <TableCardHeader name={name} action="Add Member" onClick={onAdd} />
      ) : (
        <TableCardHeader name={name} disabled />
      )}
      <CollapsibleRowTable data={data} columns={columns as any} />
      <ModalForm
        {...({ id: 'add-button' } as any)}
        title={`Add ${name}`}
        onSubmit={onSubmit}
        isOpen={isOpenAdd}
        onClose={onCloseAdd}
        fields={fields}
        {...({ fieldWidth: 300 } as any)}
      />
      <ModalForm
        {...({ id: 'edit-button' } as any)}
        title="Edit Member"
        isOpen={isOpenEdit}
        onSubmit={handleUpdateMember}
        onClose={onCloseEdit}
        fields={fields}
        initialValues={row}
        {...({ fieldWidth: 300 } as any)}
      />
    </div>
  </>
);

interface AddMemberTableProps {
  name: string;
  data: any[];
  columns: any[];
  onSubmit: (values: any) => void;
  isOpen: boolean;
  fields: any[];
  onClick: () => void;
  onClose: () => void;
  canEdit?: boolean;
}

const AddMemberTable = ({
  name,
  data,
  columns,
  onSubmit,
  isOpen,
  fields,
  onClick,
  onClose,
  canEdit,
}: AddMemberTableProps) => (
  <>
    <TableCardHeader
      name={name}
      action="Add Member"
      onClick={onClick}
      disabled={!canEdit}
    />
    <Table data={data} columns={columns} />
    <ModalForm
      title={`Add ${name}`}
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      fields={fields}
      fieldWidth={300}
    />
  </>
);

export default AddMemberTable;
